export default {
  meta: {
    title: '需求管理'
  }
};
